import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const HeaderItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    justify-content: space-between;
  }
`;
export const NavTextLink = styled(NavLink)`
  align-self: center;
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const ArrowBack = styled.img`
  height: 25px;
  width: auto;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  color: #1a1a32;
  font-weight: 600;
`;

export const Body = styled.div`
  flex: 1;
  width: 100%;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const FooterItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
`;

export const FooterText = styled.p`
  font: normal normal normal 16px Biotif;
`;

export const ColumnHeader = styled.div``;

export const BeneficiariesContainer = styled.div`
  max-height: 50px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  &:hover > #tooltip {
    display: initial;
  }
`;

export const RelativeContainer = styled.div`
  position: relative;
  display: none;
`;

export const TooltipText = styled.span`
  min-width: 200px;
  background-color: #fff;
  color: #1c1b3a;
  text-align: center;
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 20px;
`;
